import { P } from '@dnb/eufemia';

import { AccessGrid } from '../AccessGrid';

export function ApiKeyAccess({ hasLiveAccess }: { hasLiveAccess: boolean }) {
  const rows = [
    {
      label: <P>API Key</P>,
      hasTestAccess: true,
      hasLiveAccess: hasLiveAccess,
    },
  ];

  return <AccessGrid rows={rows} />;
}
